export default __webpack_public_path__ + "static/media/bannerr4.ce1534ac.webp";